import { useTranslation } from 'react-i18next';
import 'twin.macro';

const PreStartCountdown = ({ value }) => {
  const { t } = useTranslation('exercise');
  if (value === null) {
    return null;
  }

  return (
    <div
      tw="fixed inset-0 z-[260] flex items-center justify-center pointer-events-none"
      data-testid="pre-start-count"
    >
      <div tw="flex min-w-[170px] max-lg:w-[350px] max-lg:max-w-[90vw] flex-col items-center gap-3 rounded-[10px] max-lg:rounded-[12px] border border-white/20 max-lg:border-[#6d737b] bg-black/55 max-lg:bg-[rgba(39,39,39,0.8)] px-6 py-4 max-lg:p-10 text-white shadow-[0_18px_45px_rgba(0,0,0,0.35)] backdrop-blur-[2px]">
        <p tw="text-[18px] max-lg:text-[40px] font-[800] leading-none">
          {t('preStartCountdown.getReady')}
        </p>
        <div tw="mt-3 max-lg:mt-0 flex h-[104px] w-[104px] max-lg:h-[180px] max-lg:w-[180px] items-center justify-center rounded-full border-[4px] max-lg:border-[9px] border-white bg-white/10">
          <span tw="text-[58px] max-lg:text-[100px] font-[800] leading-none">{value}</span>
        </div>
      </div>
    </div>
  );
};

export default PreStartCountdown;
